import type {PartialLearningTimeInfo} from "@khan/analytics-learning-time";
// eslint-disable-next-line no-restricted-imports -- TODO: Migrate to analytics/learning-time
import * as BigBingoInternals from "@khan/analytics-learning-time/bigbingo-internals";

import type {Conversion} from "../types.ts";

export async function markConversion(
    conversion: Conversion | ReadonlyArray<Conversion>,
    learningTimeInfo: PartialLearningTimeInfo,
): Promise<Response | void> {
    const conversions = Array.isArray(conversion) ? conversion : [conversion];

    const response = await BigBingoInternals.markConversionsWithExtras(
        conversions,
        learningTimeInfo,
    );
    return response;
}
